import React, { useEffect, useState, useReducer } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Switch from '@mui/material/Switch';
import { Box } from '@mui/system';
import { setSnackBarAlert, findAllModules, caughtError } from '../../redux';
import getAppConfig from '../../config';
const config = getAppConfig();

const initialState = {
   moduleName: '',
   active: false
}

const reducer = (state, action) => {
  return {
  ...state,
  ...action
  }
}

const EditForm = (props) => {

  const [state, updateState] = useReducer(reducer, initialState);
  const [loading, setLoading] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const dispatch = useDispatch();

  const handleInputChange = (event) => {
    if(event.target.type === 'checkbox'){
      updateState({ [event.target.name]: event.target.checked });
    } else {
      updateState({ [event.target.name]: event.target.value });
    }
  }

  useEffect(() => {
    if(loading && props.modalDiaLogId && props.modalDiaLogId > 0) {
      let URL = `${config.api.URL}/module/${props.modalDiaLogId}`;
      axios.get(URL).then(response => {
        updateState({
          moduleName: response.data.data.moduleName,
          active: Boolean(response.data.data.active)
        });
        setBtnDisabled(false);
        setLoading(false);
      }).catch(error => {
        console.log(error);
        setLoading(false);
      })
    }
  }, [loading, props]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if(state.moduleName === '') {
      dispatch(setSnackBarAlert({
        openSnackBar: true,
        severity: 'error',
        message: `moduleName is required`
      }));
      return false;
    }

    setBtnDisabled(true);
    axios.patch(`${config.api.URL}/module/${props.modalDiaLogId}`, state).then(response => {
      dispatch(findAllModules(props.filterInput));
      props.setOpen(false);
    }).catch(error => {
      setBtnDisabled(false);
      dispatch(caughtError(error));
    });
  }

  let _content = null
  if(loading === false) {
    _content = <form onSubmit={handleSubmit}>
      <DialogContent sx={{ marginTop: "-20px" }} >

        <TextField
          value={state.moduleName}
          onChange={handleInputChange}
          name="moduleName"
          label="Module Name"
          margin="dense"
          type="text"
          fullWidth
          variant="outlined"
          required
        />

        <Box>
          <FormControlLabel
            className="float-end"
            control={<Switch
              name="active"
              checked={state.active}
              onChange={handleInputChange}
              />}
            label="Active"
            labelPlacement="start" />
        </Box>

      </DialogContent>
      <DialogActions>
        <button className="btn btn-secondary" onClick={ (e) => {
            e.preventDefault();
            props.setOpen(false);
          } }>Cancel</button>
        <button disabled={btnDisabled} type="submit" className="btn btn-primary" >Update Module</button>
      </DialogActions>
    </form>
  }

  return _content

}

export default EditForm;
